import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ResizeService } from 'src/app/services/resize.service';
import { RouteLocalizationPipe } from 'src/app/pipes/route-localization.pipe'
import { TranslationService } from "src/app/i18n/translation.service";
import { Store } from '@ngrx/store';
import { selectVisitedPromotions } from 'src/app/store/promotions/promotions.selectors';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuItemComponent implements OnInit {
  lang: string = "en";
  @Input() pageType: string = '';
  @Input() isStickyEnabled: boolean = false;
  @Input() promotionList: any = [];
  promotionItem: any = {
    date: new Date(),
    img: '',
    title: 'Toyo Tires - Special Offer',
    desc: 'Buy 4 TOYO TIRES and get a free gift on',
    link: ''
  };
  @Input() data: any;
  @Input() id: string = "";
  leftPosition: Number = 0;
  isHoverEnabled: boolean = false;
  @Output() closeMobileMenu: EventEmitter<boolean> = new EventEmitter();
  visitedPromotions: any = [];
  private routerSubscription: Subscription = new Subscription();
  disableMenu: boolean = false;
  @ViewChild('itemEle') itemEle!: ElementRef;
  @ViewChild('subMenuItem') subMenuItem!: ElementRef;

  constructor(
    private resizeService: ResizeService,
    private router: Router,
    private routeLocalizationPipe: RouteLocalizationPipe,
    private TranslationService: TranslationService,
    private store: Store,
  ) {
    this.lang = this.TranslationService.getSelectedLanguage();
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.disableMenu = true;
        setTimeout(() => {
          this.disableMenu = false;
        }, 1000);
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up router subscription when the component is destroyed
    this.routerSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.store.select(selectVisitedPromotions).subscribe((promotions) => {
      this.visitedPromotions = promotions.length > 0 ? promotions : []
    });
  }
   showSubMenu = false;

    toggleSubMenu(event: MouseEvent): void {
      event.preventDefault();
      event.stopPropagation();
      this.showSubMenu = !this.showSubMenu;
    }

  menuItemClick(event: any) {
    if ((this.isTouchDevice()) || (!this.isTouchDevice() && !this.isActingAsDesktop())) this.toggleMenu(event, 'click');
  }

  mouseenter(event: any) {
    if (!this.isTouchDevice() && this.isActingAsDesktop() && !this.isHoverEnabled) this.toggleMenu(event, 'mouse');
  }

  mouseleave(event: any) {
    if (this.isActingAsDesktop() && this.isHoverEnabled) {
      this.toggleMenu(event, 'mouse');
    }
  }

  pauseVideo() {
    if (typeof window !== 'undefined') {
      const videoTag: any = document.querySelector(`#${this.id} video`);
      if (videoTag) videoTag.pause();
    }
  }

  toggleItemMenu({ target }: any) {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        const itemMenuContainer: any = this.subMenuItem?.nativeElement;
        const screenWidth = this.resizeService.getWindowWidth();
        const padding = screenWidth > 1280 ? 97 : 16;
        if (itemMenuContainer) {
          const mainMenuItemOffsetLeft = this.itemEle?.nativeElement?.offsetLeft;
          const subMenuWidth = itemMenuContainer.offsetWidth;
          const subMenuHalfWidth = subMenuWidth / 2;
          if (mainMenuItemOffsetLeft - subMenuHalfWidth < 0) {
            this.leftPosition = -(mainMenuItemOffsetLeft - padding);
          } else if (mainMenuItemOffsetLeft + subMenuHalfWidth > screenWidth) {
            this.leftPosition = -(subMenuWidth - (screenWidth - mainMenuItemOffsetLeft) + padding);
          } else {
            if (mainMenuItemOffsetLeft - subMenuHalfWidth < padding) {
              this.leftPosition = -(subMenuHalfWidth - (mainMenuItemOffsetLeft - subMenuHalfWidth));
            } else {
              const restAtRight = screenWidth - (mainMenuItemOffsetLeft - subMenuHalfWidth + subMenuWidth);
              const diff = restAtRight < padding ? padding - restAtRight : 0;
              this.leftPosition = -(subMenuHalfWidth + diff);
            }
          }
        }
      });
    }
  }

  clickMenuItem(event: any, data: any) {
    if (!data?.subMenu) {
      this.closeMenu();
      this.router.navigate([this.routeLocalizationPipe.transform(data?.link)]);
    }
  }

  closeMenu() {
    this.toggleCloseMenu();
    this.closeMobileMenu.emit(true);
  }

  isExternalMethod(link: string) {
    if (!link) return false;
    if (
      link.startsWith('//') ||
      link.startsWith('http://') ||
      link.startsWith('https://') ||
      link.startsWith('www.')
    ) {
      return true;
    }
    return false;
  }


  isPromotionAndThereIsItemsNotVisited(link: string) {
    if (link !== '/promotions') return false;
    return !this.promotionList.every((item: any) => this.visitedPromotions.includes(item));
  }

  isTouchDevice() {
    // Check for touch capability with both matchMedia and navigator
    return (
      ("ontouchstart" in window) ||  // Detects older touch devices
      (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) || // Detects modern touch devices
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) // Ensures maxTouchPoints exists before checking
    );
  }

  isActingAsDesktop() {
    return this.resizeService.isDesktopSpecialCase();
  }

  toggleMenu(event: any, eventType: string) {
    if (!this.disableMenu) this.isHoverEnabled ? this.toggleCloseMenu(event, eventType) : this.toggleOpenMenu(event, eventType);
  }

  toggleOpenMenu(event: any, eventType: string) {
    event.stopPropagation();
    this.isHoverEnabled = !this.isHoverEnabled;
    this.toggleItemMenu(event);
  }

  toggleCloseMenu(event: any = null, eventType: string = '') {
    if (event) event.stopPropagation();
    this.isHoverEnabled = false;
    this.pauseVideo();
  }

}
